import type { TypedReadSchema, TypedReadSchemaItem } from '@common/formEngine/typedReadSchema.types';

export type AdviesAan = {
    advies_aan_chirurg: string | null;
    advies_aan_huisarts: string | null;
    advies_aan_patient: string | null;
};

export type ConclusieAanvullend = {
    conclusie_aanvullend_diabetes_mellitus: boolean;
    conclusie_aanvullend_hydrochloorthiazide: boolean;
    conclusie_aanvullend_psychofarmaca: boolean;
    conclusie_aanvullend_roken: boolean;
};

export type ConclusieAanvullendReadLabel =
    | 'Conclusie gebruik NSAID'
    | 'Conclusie gebruik anticonceptiva'
    | 'Conclusie diabetes mellitus'
    | 'Conclusie gebruik hydrochloorthiazide'
    | 'Conclusie gebruik psychofarmaca'
    | 'Conclusie roken';

export type ConclusieAanvullendReadKey =
    | `${keyof ConclusieAanvullend}_text`
    | 'conclusie_aanvullend_NSAID_text'
    | 'conclusie_aanvullend_anticonceptiva_text';

export const conclusieAanvullendSectionItems: TypedReadSchemaItem<
    ConclusieAanvullendReadKey,
    ConclusieAanvullendReadLabel
>[] = [
    { key: 'conclusie_aanvullend_NSAID_text', label: 'Conclusie gebruik NSAID' },
    { key: 'conclusie_aanvullend_anticonceptiva_text', label: 'Conclusie gebruik anticonceptiva' },
    { key: 'conclusie_aanvullend_diabetes_mellitus_text', label: 'Conclusie diabetes mellitus' },
    { key: 'conclusie_aanvullend_hydrochloorthiazide_text', label: 'Conclusie gebruik hydrochloorthiazide' },
    { key: 'conclusie_aanvullend_psychofarmaca_text', label: 'Conclusie gebruik psychofarmaca' },
    { key: 'conclusie_aanvullend_roken_text', label: 'Conclusie roken' },
];

export type IndicatieVerwijzing = {
    indicatie_voor_verwijzing_diabetes: boolean;
    indicatie_voor_verwijzing_hartfalen: boolean;
    indicatie_voor_verwijzing_hypertensie: boolean;
    indicatie_voor_verwijzing_medicatie: boolean;
    indicatie_voor_verwijzing_nefrologie: boolean;
    indicatie_voor_verwijzing_obesitas_specifiek: boolean;
    indicatie_voor_verwijzing_osteoporose: boolean;
    indicatie_voor_verwijzing_overig: boolean;
    indicatie_voor_verwijzing_overig_toelichting: string | null;
};

export const indicatieVerwijzingSectionTitle = 'Indicatie voor verwijzing' as const;
export type IndicatieVerwijzingSectionTitle = typeof indicatieVerwijzingSectionTitle;

export type IndicatieVoorVerwijzingReadLabel =
    | 'Indicatie voor verwijzing diabetes'
    | 'Indicatie voor verwijzing hartfalen'
    | 'Indicatie voor verwijzing hypertensie'
    | 'Indicatie voor verwijzing medicatie'
    | 'Indicatie voor verwijzing nefrologie'
    | 'Indicatie voor verwijzing obesitas-specifiek'
    | 'Indicatie voor verwijzing osteoporose'
    | 'Overige indicatie voor verwijzing';

type IndicatieVerwijzingOmitOverig = Omit<
    IndicatieVerwijzing,
    'indicatie_voor_verwijzing_overig' | 'indicatie_voor_verwijzing_overig_toelichting'
>;
export type IndicatieVerwijzingReadKey =
    | `${keyof IndicatieVerwijzingOmitOverig}_text`
    | 'indicatie_voor_verwijzing_overig_toelichting';

export const indicatieVerwijzingReadSection: TypedReadSchema<
    IndicatieVerwijzingReadKey,
    IndicatieVoorVerwijzingReadLabel,
    IndicatieVerwijzingSectionTitle
> = {
    items: [
        { key: 'indicatie_voor_verwijzing_diabetes_text', label: 'Indicatie voor verwijzing diabetes' },
        { key: 'indicatie_voor_verwijzing_hartfalen_text', label: 'Indicatie voor verwijzing hartfalen' },
        { key: 'indicatie_voor_verwijzing_hypertensie_text', label: 'Indicatie voor verwijzing hypertensie' },
        { key: 'indicatie_voor_verwijzing_medicatie_text', label: 'Indicatie voor verwijzing medicatie' },
        { key: 'indicatie_voor_verwijzing_nefrologie_text', label: 'Indicatie voor verwijzing nefrologie' },
        {
            key: 'indicatie_voor_verwijzing_obesitas_specifiek_text',
            label: 'Indicatie voor verwijzing obesitas-specifiek',
        },
        { key: 'indicatie_voor_verwijzing_osteoporose_text', label: 'Indicatie voor verwijzing osteoporose' },
        { key: 'indicatie_voor_verwijzing_overig_toelichting', label: 'Overige indicatie voor verwijzing' },
    ],
    sectionTitle: indicatieVerwijzingSectionTitle,
};
